import { getRangeSliderToken, getTextToken, hexToRGBA } from "../fundations/palette/colorTokens";
import { Corner0, Corner2 } from "../fundations/shape/corners";
export const Slider = {
    MuiSlider: {
        defaultProps: {
            getAriaValueText: (value)=>value.toString(),
            valueLabelDisplay: "on"
        },
        styleOverrides: {
            root: {
                display: "flex",
                flexShrink: 0,
                borderRadius: Corner0,
                justifyContent: "flex-end"
            },
            thumb: ({ theme })=>({
                    backgroundColor: getRangeSliderToken("rangeSliderHandleFill", theme),
                    border: `${Corner2} solid ${getRangeSliderToken("rangeSliderHandleBorder", theme)}`,
                    "&.Mui-focusVisible": {
                        boxShadow: `0px 4px 8px -2px ${hexToRGBA(getRangeSliderToken("rangeSliderThumbShadow", theme), "0.04")}, 0px 2px 4px -2px ${hexToRGBA(getRangeSliderToken("rangeSliderThumbShadow", theme), "0.12")}`
                    },
                    "&:hover": {
                        boxShadow: `0px 4px 8px -2px ${hexToRGBA(getRangeSliderToken("rangeSliderThumbShadow", theme), "0.04")}, 0px 2px 4px -2px ${hexToRGBA(getRangeSliderToken("rangeSliderThumbShadow", theme), "0.12")}`
                    }
                }),
            track: ({ theme })=>({
                    color: getRangeSliderToken("rangeSliderProgress", theme)
                }),
            rail: ({ theme })=>({
                    backgroundColor: getRangeSliderToken("rangeSliderTrackBackground1", theme),
                    opacity: 1
                }),
            valueLabel: ({ theme })=>({
                    color: getTextToken("secondary", theme),
                    background: "none",
                    top: "45px"
                })
        }
    }
};
export default Slider;

//# sourceMappingURL=Slider.js.map